import React, { useState } from "react";
import { Link } from "react-router-dom";
import SiteLayout from "../components/SiteLayout";
import StoreBadges from "../components/StoreBadges";
import { EMAIL } from "../site/constants";
import {
  IconAcquaintance,
  IconArrow,
  IconBagSmall,
  IconCharity,
  IconFamily,
  IconFriends,
  IconHeartOutline,
} from "../site/icons";
import "./LandingPage.css";

const FOR_WHOM = [
  { label: "Familie", Icon: IconFamily },
  { label: "Vrienden", Icon: IconFriends },
  { label: "Kennissen", Icon: IconAcquaintance },
  { label: "Goed doel", Icon: IconCharity },
];

const CATEGORIES = [
  {
    name: "Boodschappen",
    meta: "Dagelijks nodig",
    bg: "#ffe8ef",
    img: "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=240&q=80",
  },
  {
    name: "Verzorging",
    meta: "Persoonlijk & baby",
    bg: "#ece7ff",
    img: "https://images.unsplash.com/photo-1556228578-0d85b1a4d571?auto=format&fit=crop&w=240&q=80",
  },
  {
    name: "Cadeaus",
    meta: "Voor speciale momenten",
    bg: "#fff3d6",
    img: "https://images.unsplash.com/photo-1549465220-1a8b9238cd48?auto=format&fit=crop&w=240&q=80",
  },
  {
    name: "Familiepakketten",
    meta: "Compleet samengesteld",
    bg: "#e4f7ea",
    img: "https://images.unsplash.com/photo-1607083206869-4c7672e72a8a?auto=format&fit=crop&w=240&q=80",
  },
  {
    name: "Dranken",
    meta: "Fris & meer",
    bg: "#e7f1ff",
    img: "https://images.unsplash.com/photo-1622597467836-f3285f2131b8?auto=format&fit=crop&w=240&q=80",
  },
  {
    name: "Fruit",
    meta: "Vers & zoet",
    bg: "#fff0d6",
    img: "/images/apple.jpg",
  },
  {
    name: "Speciale momenten",
    meta: "Owru Yari & meer",
    bg: "#e8faf4",
    img: "https://images.unsplash.com/photo-1513151233558-d860c5398176?auto=format&fit=crop&w=240&q=80",
  },
];

const HOT_DEALS = [
  {
    name: "Eieren",
    rating: "5.00",
    line1: "Suriwebwinkel",
    line2: "Verse eieren uit het assortiment",
    img: "https://images.unsplash.com/photo-1506976785307-8732e854ad03?auto=format&fit=crop&w=400&q=80",
  },
  {
    name: "Vlees (blokjes)",
    rating: "4.90",
    line1: "Suriwebwinkel",
    line2: "Voor dagelijkse maaltijden thuis",
    img: "https://images.unsplash.com/photo-1607623814075-e51df1bdc82f?auto=format&fit=crop&w=400&q=80",
  },
  {
    name: "Vijgen",
    rating: "4.80",
    line1: "Suriwebwinkel",
    line2: "Zoet fruit voor speciale momenten",
    img: "https://images.unsplash.com/photo-1577234286642-fc512a5f8f11?auto=format&fit=crop&w=400&q=80",
  },
  {
    name: "Aardappelen",
    rating: "5.00",
    line1: "Suriwebwinkel",
    line2: "Basis voor elk familiegerecht",
    img: "https://images.unsplash.com/photo-1518977956812-cd3dbadaaf31?auto=format&fit=crop&w=400&q=80",
  },
];

const AUDIENCE = [
  {
    title: "Voor je ouders",
    body: "Boodschappen, verzorging en huishoudelijke benodigdheden voor moeder, vader, opa of oma.",
  },
  {
    title: "Voor familie",
    body: "Help met school, het huishouden of andere dagelijkse behoeften.",
  },
  {
    title: "Voor vrienden",
    body: "Verras iemand met een cadeau, bloemen of een persoonlijk pakket.",
  },
  {
    title: "Voor bijzondere momenten",
    body: "Verjaardag, jubileum, geboorte, feestdag of gewoon zomaar.",
  },
];

const TESTIMONIALS = [
  {
    quote:
      "Vanuit België kon ik eenvoudig boodschappen voor mijn moeder in Paramaribo bestellen. Ik hoefde niets zelf op te sturen en werd goed op de hoogte gehouden.",
    name: "Sandra",
    city: "Antwerpen",
  },
  {
    quote:
      "Mijn familie woont in Suriname en ik woon zelf in Frankrijk. Via Suriwebwinkel kan ik toch regelmatig iets voor ze regelen.",
    name: "Marc",
    city: "Parijs",
  },
  {
    quote:
      "Voor de verjaardag van mijn tante hebben we vanuit Duitsland een verrassingspakket besteld. Alles werd netjes bezorgd.",
    name: "Lena",
    city: "Düsseldorf",
  },
  {
    quote:
      "Het geeft mij een goed gevoel dat ik precies kan zien welke producten mijn vader ontvangt.",
    name: "Kevin",
    city: "Rotterdam",
  },
];

function Stars({ rating }) {
  return (
    <div className="lp-deal-stars" aria-label={`Beoordeling ${rating}`}>
      {[0, 1, 2, 3, 4].map((i) => (
        <span key={i} className="lp-star">
          ★
        </span>
      ))}
      <span className="lp-deal-rating">({rating})</span>
    </div>
  );
}

export default function LandingPage() {
  const [email, setEmail] = useState("");

  const onNewsletter = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    window.location.href = `mailto:${EMAIL}?subject=${encodeURIComponent(
      "Aanmelding nieuwsbrief"
    )}&body=${encodeURIComponent(
      `Graag aanmelden voor updates: ${email}`
    )}`;
  };

  return (
    <SiteLayout>
      {/* Hero */}
      <section className="lp-hero" id="home">
        <div className="lp-wrap">
          <div className="lp-hero-card">
            <div className="lp-hero-copy">
              <span className="lp-kicker">Europa → Suriname</span>
              <h1>Vanuit Europa iets betekenen voor iemand in Suriname</h1>
              <p>
                Bestel eenvoudig boodschappen, cadeaus en dagelijkse
                benodigdheden voor familie en vrienden in Suriname. Of je nu in
                Nederland, België, Frankrijk, Duitsland, het Verenigd Koninkrijk
                of ergens anders in Europa woont.
              </p>
              <div className="lp-for-whom" aria-label="Voor wie">
                <span className="lp-for-whom-label">Voor wie?</span>
                <ul className="lp-for-whom-list">
                  {FOR_WHOM.map(({ label, Icon }) => (
                    <li key={label} className="lp-for-whom-item">
                      <span className="lp-for-whom-icon">
                        <Icon />
                      </span>
                      <span>{label}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="lp-cta-row">
                <Link className="lp-btn-primary" to="/producten">
                  Bekijk onze producten
                  <span className="lp-btn-arrow">
                    <IconArrow />
                  </span>
                </Link>
                <Link className="lp-btn-ghost" to="/hoe-het-werkt">
                  Start met bestellen
                </Link>
              </div>
              <StoreBadges className="lp-hero-badges" />
              <p className="lp-hero-note">
                Jij kiest en betaalt online. Wij zorgen voor de lokale
                verwerking en bezorging in Suriname.
              </p>
            </div>

            <div className="lp-hero-visual">
              <img
                className="lp-hero-photo"
                src="https://images.unsplash.com/photo-1461354464878-ad92f492a5a0?auto=format&fit=crop&w=900&q=80"
                alt="Verse producten voor je familie"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Dichtbij teaser */}
      <section className="lp-section">
        <div className="lp-wrap">
          <div className="lp-offers-head">
            <h2 className="lp-section-title">Dichtbij, waar je ook woont</h2>
            <Link className="lp-btn-outline" to="/hoe-het-werkt">
              Hoe het werkt
              <span className="lp-mini-arrow">
                <IconArrow />
              </span>
            </Link>
          </div>
          <div className="lp-offer-banner">
            <div>
              <span className="lp-pill">Geen internationale pakketten</span>
              <h2>Afstand hoeft geen belemmering te zijn</h2>
              <p>
                Met Suriwebwinkel hoef je geen dozen in te pakken, geen
                verzendbedrijf te zoeken en niet wekenlang te wachten. Je bestelt
                rechtstreeks vanuit Europa en wij bezorgen lokaal in Suriname.
              </p>
              <p className="lp-emotion-strong" style={{ color: "inherit" }}>
                Geen internationale pakketten. Geen ingewikkelde verzending.
                Gewoon goed geregeld.
              </p>
              <div className="lp-store-row" style={{ marginTop: 18 }}>
                <Link className="lp-store-btn" to="/waarom">
                  Waarom Suriwebwinkel
                </Link>
                <Link className="lp-store-btn lp-store-btn--ghost" to="/europa">
                  Bestellen vanuit Europa
                </Link>
              </div>
            </div>
            <div className="lp-offer-visual">
              <img
                src="https://images.unsplash.com/photo-1610348725531-843dff563e2c?auto=format&fit=crop&w=1000&q=80"
                alt="Mand vol verse producten"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="lp-section" id="producten">
        <div className="lp-wrap">
          <h2 className="lp-section-title">Alles wat je familie nodig heeft</h2>
          <p className="lp-section-lead">
            Van dagelijkse boodschappen tot cadeaus en speciale momenten.
          </p>
          <div className="lp-categories">
            {CATEGORIES.map((cat) => (
              <Link
                key={cat.name}
                to="/producten"
                className="lp-cat"
                style={{ background: cat.bg }}
              >
                <div className="lp-cat-img">
                  <img src={cat.img} alt={cat.name} />
                </div>
                <h3>{cat.name}</h3>
                <p>{cat.meta}</p>
              </Link>
            ))}
          </div>
          <div className="lp-center-cta">
            <Link className="lp-btn-ghost" to="/producten">
              Bekijk alle producten
            </Link>
          </div>
        </div>
      </section>

      {/* Hot deals */}
      <section className="lp-section lp-deals-section" id="deals">
        <div className="lp-wrap">
          <h2 className="lp-section-title">Onze wekelijkse hot deals</h2>
          <div className="lp-deals-stage">
            <div className="lp-deals-banner">
              <h3 className="lp-deals-headline">
                Frisse, premium producten voor je familie.
              </h3>
              <div className="lp-starburst" aria-hidden="true">
                <span>
                  30%
                  <small>KORTING</small>
                </span>
              </div>
              <div className="lp-deals-banner-img">
                <img
                  src="https://images.unsplash.com/photo-1508747703725-719777637510?auto=format&fit=crop&w=700&q=80"
                  alt="Premium noten en producten"
                />
              </div>
            </div>
            <div className="lp-deal-cards">
              {HOT_DEALS.map((deal) => (
                <article key={deal.name} className="lp-deal-card">
                  <div className="lp-deal-card-top">
                    <h4>{deal.name}</h4>
                    <span className="lp-deal-heart" aria-hidden="true">
                      <IconHeartOutline />
                    </span>
                  </div>
                  <div className="lp-deal-img-wrap">
                    <img src={deal.img} alt={deal.name} />
                  </div>
                  <Stars rating={deal.rating} />
                  <div className="lp-deal-card-foot">
                    <div>
                      <p>{deal.line1}</p>
                      <p>{deal.line2}</p>
                    </div>
                    <span className="lp-deal-bag" aria-hidden="true">
                      <IconBagSmall />
                    </span>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Audience */}
      <section className="lp-section">
        <div className="lp-wrap">
          <h2 className="lp-section-title">
            Voor familie en vrienden in Suriname
          </h2>
          <div className="lp-card-grid">
            {AUDIENCE.map((item) => (
              <article key={item.title} className="lp-info-card">
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </article>
            ))}
          </div>
          <div className="lp-center-cta">
            <Link className="lp-btn-outline" to="/momenten">
              Voor elk bijzonder moment
              <span className="lp-mini-arrow">
                <IconArrow />
              </span>
            </Link>
          </div>
        </div>
      </section>

      {/* Feature promos */}
      <section className="lp-wrap lp-promos">
        <article className="lp-promo lp-promo--dark">
          <div>
            <span className="lp-pill">Familieplan</span>
            <h3>Iedere maand ondersteuning sturen</h3>
            <p>
              Stel een terugkerend pakket samen en ontvang een herinnering
              voordat we je bestelling verwerken.
            </p>
            <Link className="lp-promo-link" to="/familieplan">
              Ontdek het Familieplan →
            </Link>
          </div>
          <div className="lp-promo-badge">
            <img src="/images/app-icon.png" alt="" />
          </div>
        </article>
        <article className="lp-promo lp-promo--mint">
          <div>
            <span className="lp-pill">Verlanglijst</span>
            <h3>Laat de ontvanger zelf kiezen</h3>
            <p>
              De ontvanger maakt een lijst, jij betaalt vanuit Europa, wij
              bezorgen in Suriname.
            </p>
            <Link
              className="lp-promo-link lp-promo-link--dark"
              to="/verlanglijst"
            >
              Maak een verlanglijst →
            </Link>
          </div>
          <div className="lp-promo-badge">
            <img src="/images/logo-glow.png" alt="" />
          </div>
        </article>
      </section>

      {/* Packages teaser */}
      <section className="lp-section">
        <div className="lp-wrap">
          <div className="lp-offers-head">
            <h2 className="lp-section-title">Samengestelde familiepakketten</h2>
            <Link className="lp-btn-outline" to="/pakketten">
              Bekijk alle pakketten
              <span className="lp-mini-arrow">
                <IconArrow />
              </span>
            </Link>
          </div>
          <div className="lp-packages">
            {[
              {
                title: "Familie Boodschappenpakket",
                body: "Populaire dagelijkse boodschappen voor een huishouden.",
                bg: "#ffe8ef",
              },
              {
                title: "Mama & Papa Pakket",
                body: "Boodschappen en verzorging voor ouders en ouderen.",
                bg: "#e4f7ea",
              },
              {
                title: "Verjaardagspakket",
                body: "Lekkernijen, drankjes en een persoonlijke boodschap.",
                bg: "#fff3d6",
              },
              {
                title: "Maandpakket",
                body: "Voor wie familie regelmatig wil ondersteunen.",
                bg: "#e7f1ff",
              },
            ].map((pkg) => (
              <Link
                key={pkg.title}
                to="/pakketten"
                className="lp-package"
                style={{ background: pkg.bg }}
              >
                <h3>{pkg.title}</h3>
                <p>{pkg.body}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Emotion */}
      <section className="lp-section">
        <div className="lp-wrap">
          <div className="lp-emotion">
            <span className="lp-pill">Meer dan geld sturen</span>
            <h2>Voor je familie en vrienden zorgen kent geen afstand</h2>
            <p>
              Bestel boodschappen. Stuur een cadeau. Ondersteun een gezin.
              Verras iemand op een bijzondere dag. Waar je ook in Europa woont —
              met Suriwebwinkel blijf je verbonden.
            </p>
            <StoreBadges className="lp-store-badges--center" />
            <div className="lp-store-row lp-store-row--center" style={{ marginTop: 16 }}>
              <Link
                className="lp-btn-ghost"
                to="/zakelijk"
                style={{ color: "#fff", borderColor: "rgba(255,255,255,.7)" }}
              >
                Zakelijke bestellingen
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Reviews */}
      <section className="lp-section">
        <div className="lp-wrap">
          <h2 className="lp-section-title">Wat onze klanten zeggen</h2>
          <div className="lp-reviews lp-reviews--4">
            {TESTIMONIALS.map((t) => (
              <blockquote key={t.name} className="lp-review">
                <p>“{t.quote}”</p>
                <footer>
                  — {t.name}, {t.city}
                </footer>
              </blockquote>
            ))}
          </div>
        </div>
      </section>

      {/* App + FAQ teaser */}
      <section className="lp-section" id="download">
        <div className="lp-wrap">
          <div className="lp-final-cta">
            <h2>Download de Suriwebwinkel-app</h2>
            <p>
              Bestel nog gemakkelijker, bewaar adressen, ontvang verlanglijsten
              en volg je bezorgupdates.
            </p>
            <StoreBadges className="lp-store-badges--center" />
            <div className="lp-store-row lp-store-row--center" style={{ marginTop: 16 }}>
              <Link className="lp-store-btn lp-store-btn--ghost" to="/faq">
                Veelgestelde vragen
              </Link>
              <Link className="lp-store-btn lp-store-btn--ghost" to="/app">
                Meer over de app
              </Link>
            </div>
            <div className="lp-about-visual lp-final-icon">
              <img src="/images/app-icon.png" alt="Suriwebwinkel app" />
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section className="lp-section">
        <div className="lp-wrap">
          <div className="lp-newsletter">
            <div>
              <h2>Blijf op de hoogte</h2>
              <p>
                Ontvang nieuwe producten, aanbiedingen, familiepakketten en
                speciale acties rechtstreeks via e-mail.
              </p>
            </div>
            <form className="lp-newsletter-form" onSubmit={onNewsletter}>
              <label className="lp-sr-only" htmlFor="nieuwsbrief-email">
                E-mailadres
              </label>
              <input
                id="nieuwsbrief-email"
                type="email"
                required
                placeholder="E-mailadres"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button type="submit" className="lp-btn-primary">
                Aanmelden
                <span className="lp-btn-arrow">
                  <IconArrow />
                </span>
              </button>
            </form>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
